import { injectable } from '@servicetitan/react-ioc';
import { action, computed, makeObservable, observable } from 'mobx';
import { AddressModel } from '../../../../../api/portal-customers.api';

@injectable()
export class ServiceAgreementCoveredLocationsDrawerStore {
    @observable coveredLocations?: AddressModel[];

    @computed get isOpen() {
        return !!this.coveredLocations;
    }

    constructor() {
        makeObservable(this);
    }

    @action
    open = (coveredLocations: AddressModel[]) => {
        this.coveredLocations = coveredLocations;
    };

    @action
    close = () => {
        this.coveredLocations = undefined;
    };
}
